import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getCartItemFromProduct, setCartItem } from '../../CartActions';
import { getProducts } from '../../../Product/ProductActions';
import { getReferral } from '../../../App/AppActions';
import withRouter from '../../../../components/Router/WithRouter';

function CartAutoAddToCart({ dispatch, search, intl, products = [], referral = '', isMounted = false }) {
	useEffect(() => {
        // Handle automatic add to cart: ?addtocart=product-slug:2,productID:1
        if(search.addtocart) {
            search.addtocart.split(',').forEach(itemData => {
                const [id, qty, conversationId] = itemData.split(':');
                if(id) {
                    const product = products.find(product => product._id === id || (product.slug || '').toLowerCase() === id.toLowerCase());
                    if(product) {
                        dispatch(setCartItem(getCartItemFromProduct({ ...product, conversationId }, qty || 1, intl.locale, { referral })));
                    } else {
                        console.error(itemData, id, qty, conversationId, products);
                    }
                }
            });
        }
	}, [isMounted]);
	return null;
}

function mapStateToProps(store, props) {
	return {
        products: getProducts(store, { isActive: true, isVariation: false }),
        referral: getReferral(store),
		isMounted: store.app.isMounted,
	};
}

CartAutoAddToCart.propTypes = {
	dispatch: PropTypes.func.isRequired,
	search: PropTypes.object.isRequired,
	intl: PropTypes.object.isRequired,
	products: PropTypes.arrayOf(PropTypes.object),
	referral: PropTypes.string,
	isMounted: PropTypes.bool,
};

export default connect(mapStateToProps)(withRouter(injectIntl(CartAutoAddToCart), ['search']));
